<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Site Restrictions"
              icon="fas fa-list"
              buttonLabel="ADD RESTRICTION"
              buttonIcon="fas fa-plus"
              (buttonClick)="showAddRestrictionModal()"
              >
            </card-section-header>
            <div class="mb-2 animated fadeIn">
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12" *ngIf="selectedSite">
                  <p-table [value]="selectedSite.restrictions" [autoLayout]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width:50%">Restriction Description</th>
                        <th>Type</th>
                        <th>Created By</th>
                        <th>Created Date</th>
                        <th>Last Modified By</th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-restriction>
                      <tr>
                        <td><p class="asset-restriction"><i class="fas fa-exclamation-triangle"></i>&nbsp;{{ restriction.description }}</p></td>
                        <td>
                          <span *ngIf="restriction.type === 'OPERATIONAL'" class="badge badge-pill badge-warning">Operational</span>
                          <span *ngIf="restriction.type === 'HEALTH_AND_SAFETY'" class="badge badge-pill badge-danger">Health & Safety</span>
                          <span *ngIf="restriction.type === 'GENERAL'" class="badge badge-pill badge-primary">General</span>
                        </td>
                        <td>{{ restriction.createdBy }}</td>
                        <td><date-friendly [value]="restriction.createdDate"></date-friendly></td>
                        <td>{{ restriction.lastModifiedBy }}</td>
                        <td><button type="button" class="btn btn-danger btn-link" (click)="removeRestriction(restriction.id)">remove</button></td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="4">No restrictions found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add a restriction -->
<p-dialog header="Add Site Restriction" [(visible)]="isAddRestrictionModalShown" modal="true"  [style]="{'min-width': '600px'}" [dismissableMask]="true" [baseZIndex]="1000000">
  <form [formGroup]="addSiteRestrictionForm" (ngSubmit)="onAddSiteRestrictionFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Restriction Description</label>
          <input type="text" class="form-control" formControlName="description" placeholder="restriction description" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Type<span class="required-star"> *</span></label>
          <p-dropdown class="form-control"
            formControlName="type"
            [options]="restrictionType"
            optionLabel="label"
            placeholder="Select Restriction Type...">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onAddSiteRestrictionFormSubmit()" [disabled]="!addSiteRestrictionForm.valid || isSaving" class="my-2 btn btn-round btn-sm btn-success">Add Restriction</button>
    <button type="button" (click)="isAddRestrictionModalShown = false" class="my-2 btn btn-round btn-sm btn-default">Cancel</button>
  </p-footer>
</p-dialog>
